// ==========================================
// Onboarding Steps Data
// ==========================================

import {
  DashboardVisibilityIcon,
  GymFeaturesIcon,
  GymOwnerIcon,
  ImportMembersIcon,
  PlanCreationIcon,
  MembersIcon,
  TrainerIncentivesIcon,
  FitnessCenterIcon,
  SalesTrackingIcon,
  TargetManagementIcon,
  LeaveManagementIcon,
  ReportsAnalyticsIcon,
  TaskSOPIcon,
  CTODashboardIcon,
  UserManagementIcon,
} from "../icons/OnboardingIcons";

export const onboardingSteps = [
  {
    id: 1,
    title: "Plan Creation",
    subtitle: "Create subscription plans",
  },
  {
    id: 2,
    title: "Gym Owner Onboardi...",
    subtitle: "Register and verify gym owners",
  },
  {
    id: 3,
    title: "Dashboard Visibility",
    subtitle: "Configure accessible pages",
  },
  {
    id: 4,
    title: "Gym Features",
    subtitle: "Add equipment and amenities",
  },
  {
    id: 5,
    title: "Import Members",
    subtitle: "Upload member data",
  },
];

// ==========================================
// Wizard Steps Data
// ==========================================

export const wizardSteps = [
  { id: 1, label: "Verification" },
  { id: 2, label: "Business Info" },
  { id: 3, label: "Owner Details" },
  { id: 4, label: "Plan Selection" },
];

// ==========================================
// Plan Features Data
// ==========================================

export const planFeatures = [
  { id: "members", label: "Members Management" },
  { id: "trainer_incentives", label: "Trainer Incentives" },
  { id: "fitness", label: "Fitness Center" },
  { id: "sales", label: "Sales Tracking" },
  { id: "target", label: "Target Management" },
  { id: "leave", label: "Leave Management" },
  { id: "reports", label: "Reports & Analytics" },
  { id: "task_sop", label: "Task SOP" },
  { id: "cto", label: "CTO Dashboard" },
  { id: "user", label: "User Management" },
];

// ==========================================
// Designations Data
// ==========================================

export const designations = [
  "Owner",
  "Director",
  "Managing Director",
  "CEO",
  "General Manager",
  "Partner",
];

// ==========================================
// Indian States Data
// ==========================================

export const indianStates = [
  "Andhra Pradesh",
  "Arunachal Pradesh",
  "Assam",
  "Bihar",
  "Chhattisgarh",
  "Goa",
  "Gujarat",
  "Haryana",
  "Himachal Pradesh",
  "Jharkhand",
  "Karnataka",
  "Kerala",
  "Madhya Pradesh",
  "Maharashtra",
  "Manipur",
  "Meghalaya",
  "Mizoram",
  "Nagaland",
  "Odisha",
  "Punjab",
  "Rajasthan",
  "Sikkim",
  "Tamil Nadu",
  "Telangana",
  "Tripura",
  "Uttar Pradesh",
  "Uttarakhand",
  "West Bengal",
  "Andaman and Nicobar Islands",
  "Chandigarh",
  "Dadra and Nagar Haveli and Daman and Diu",
  "Delhi",
  "Jammu and Kashmir",
  "Ladakh",
  "Lakshadweep",
  "Puducherry",
];

// ==========================================
// Plan Duration Options
// ==========================================

export const planDurations = [
  { value: "30", label: "Monthly" },
  { value: "90", label: "Quarterly" },
  { value: "365", label: "Yearly" },
];

// ==========================================
// Feature Icon Mapping Function
// ==========================================

export const getFeatureIcon = (featureId, size = 24) => {
  const iconProps = { size };
  switch (featureId) {
    case "members":
      return <MembersIcon {...iconProps} />;
    case "trainer_incentives":
      return <TrainerIncentivesIcon {...iconProps} />;
    case "fitness":
      return <FitnessCenterIcon {...iconProps} />;
    case "sales":
      return <SalesTrackingIcon {...iconProps} />;
    case "target":
      return <TargetManagementIcon {...iconProps} />;
    case "leave":
      return <LeaveManagementIcon {...iconProps} />;
    case "reports":
      return <ReportsAnalyticsIcon {...iconProps} />;
    case "task_sop":
      return <TaskSOPIcon {...iconProps} />;
    case "cto":
      return <CTODashboardIcon {...iconProps} />;
    case "user":
      return <UserManagementIcon {...iconProps} />;
    default:
      return null;
  }
};

// ==========================================
// Feature Name to Icon ID Mapping Function
// ==========================================

export const getFeatureIdFromName = (featureName) => {
  const nameLower = featureName?.toLowerCase() || '';

  if (nameLower.includes('member')) return 'members';
  if (nameLower.includes('trainer') || nameLower.includes('incentive')) return 'trainer_incentives';
  if (nameLower.includes('fitness') || nameLower.includes('center')) return 'fitness';
  if (nameLower.includes('sales') || nameLower.includes('sale')) return 'sales';
  if (nameLower.includes('target')) return 'target';
  if (nameLower.includes('leave')) return 'leave';
  if (nameLower.includes('report') || nameLower.includes('analytic')) return 'reports';
  if (nameLower.includes('task') || nameLower.includes('sop')) return 'task_sop';
  if (nameLower.includes('cto') || nameLower.includes('dashboard')) return 'cto';
  if (nameLower.includes('user')) return 'user';

  return null;
};

// ==========================================
// Step Icon Mapping Function
// ==========================================

export const getStepIcon = (stepId) => {
  switch (stepId) {
    case 1:
      return <PlanCreationIcon />;
    case 2:
      return <GymOwnerIcon />;
    case 3:
      return <DashboardVisibilityIcon />;
    case 4:
      return <GymFeaturesIcon />;
    case 5:
      return <ImportMembersIcon />;
    default:
      return null;
  }
};